var $4c962c1e2098dc65$exports = {};
$4c962c1e2098dc65$exports = {
    "breadcrumbs": `Broodkruimels`
};


export {$4c962c1e2098dc65$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
